<template>
    <v-dialog width="1000" v-model="isOpenCommunicatesSummary" persistent>
        <v-card style="width: 100% !important">
            <v-card-title>
                <v-row>
                    <v-col class="d-flex justify-center" cols="12">
                        <h3 class="font-weight-light primary--text">
                            Comunicados
                        </h3>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-row class="d-flex justify-center">
                <v-col cols="6" class="d-flex justify-center">
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                small
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                dark
                                outlined
                                color="primary"
                                v-on="on"
                                >{{ 'Mes: ' + formatDate(date) }}
                                <v-icon rigth>mdi-calendar</v-icon>
                            </v-btn>
                        </template>
                        <v-date-picker
                            color="primary"
                            v-model="date"
                            type="month"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn text color="red" @click="menu = false">
                                Cerrar
                            </v-btn>
                            <v-btn
                                depressed
                                text
                                color="primary"
                                @click="
                                    searchNewDate(date);
                                    $refs.menu.save(date);
                                "
                            >
                                Guardar
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6" class="d-flex justify-center">
                    <v-btn
                        depressed
                            @click="openCreate()"
                            color="green darken-2"
                            outlined
                            dark
                            small
                        >
                            Crear Comunicado
                            <v-icon right>mdi-table-column-plus-before</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            <v-card elevation="0" class="pa-4">
                <v-data-table
                    :headers="headers"
                    :items="communicates"
                    class="elevation-0"
                    :search="search"
                    :footer-props="footer_props"
                    :item-class="itemClass"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.created_on="{ item }">
                        {{ formatDate(item.created_on) }}
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    v-if="hasManagerPermission"
                                    fab
                                    @click="openWatch(item)"
                                    x-small
                                    color="primary"
                                    outlined
                                >
                                    <v-icon> mdi-eye </v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="hasAdminPermission"
                                    class="ml-1"
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    outlined
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card>
            <v-card-actions elevation="0" class="justify-end mt-n8">
                <v-btn
                    text
                    color="red"
                    @click="isOpenCommunicatesSummary = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
        <CommunicatesForm />
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone, objectSnakeToCamelCase } from '@/util/libUtil.js';
import CommunicatesForm from '@/components/RRHH/Communicates/CommunicatesForm.vue';

export default {
    data: () => ({
        search: '',
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        headers: [
            {
                text: 'Autor',
                value: 'sender.nombreCompleto',
                align: 'start',
            },
            {
                text: 'Título',
                value: 'messageTitle',
                align: 'start',
            },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        CommunicatesForm,
    },
    computed: {
        isOpenCommunicatesSummary: {
            get() {
                return this.$store.state.rrhh.communicates.isOpen;
            },
            set(value) {
                this.$store.commit('rrhh/isOpenCommunicatesSummary', value);
            },
        },
        ...mapState('rrhh', {
            communicates: (state) => state.communicates.communicates,
        }),
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
            hasManagerPermission: 'hasManagerPermission',
        }),
    },
    methods: {
        itemClass(item) {
            switch (item.priority) {
                case 'LOW':
                    return 'lighten-yellow-bg';
                case 'MIDDLE':
                    return 'lighten-orange-bg';
                case 'HIGH':
                    return 'lighten-red-bg';
                default:
                    return '';
            }
        },
        formatDate(date) {
            return new Date(date).toISOString().substr(0, 7);
        },
        openWatch(item) {
            let receivers = [];
            item.readReceivers.forEach((receiver) => {
                receivers.push(receiver.account);
            });
            
            let editingCommunicate = {
                'message_body': item.messageBody,
                'message_title': item.messageTitle,
                'receivers': clone(objectSnakeToCamelCase(receivers)),
                'priority': item.priority,
            }

            this.$store.commit('rrhh/communicatesType', 'EDIT');
            this.$store.commit('rrhh/communicatesForm', editingCommunicate);
            this.$store.commit('rrhh/isOpenCommunicateView', true);
        },
        openCreate() {
            this.$store.commit('rrhh/communicatesType', 'CREATE');
            this.$store.commit('rrhh/isOpenCommunicateView', true);
        },
        searchNewDate() {
            let params = {
                created_on: this.date,
            };
            if (new Date(this.date) >= this.dateActualInmutable) {
                params = { ...params, is_active: true };
            }
            this.getcommunicates(params);
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'COMMUNICATE',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        ...mapActions('rrhh', ['getCommunicates']),
    },
    watch: {},
};
</script>

<style>
.lighten-red-bg {
    background-color: #ffcdd2 !important;
}
.lighten-orange-bg {
    background-color: #fdcb81 !important;
}
.lighten-yellow-bg {
    background-color: #f9ff9e !important;
}
</style>







